const reportDB = require("../../../../../components/report/report-db");
const report = require("../../../../../components/report/report");
const style = require("../../../../../components/report/report-style");
const css = style.get();
const page = require("../../../../../components/page/page");
import { createChart } from "./chart/accountsReceivable-page-chart";

let cachedReportDateFilter = null;

export function getCachedReportDateFilter() {
  return cachedReportDateFilter;
}

export function fetchAll(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  if (detail.filterBy && detail.filterBy.endDate) {
    cachedReportDateFilter = {
      startDate: detail.filterBy.startDate || detail.filterBy.endDate,
      endDate: detail.filterBy.endDate,
    };
  } else {
    cachedReportDateFilter = null;
  }
  detail.inf = { entity: "customer", report: "account-receivable-all" };
  if (detail.sort) {
    detail.inf.sort_by = detail.sort.by;
    detail.inf.sort_dir = detail.sort.dir;
  }

  if (detail.search) {
    detail.inf.searchReceivable = detail.search;
  }

  if (detail.filterBy) {
    detail.inf.startDate = detail.filterBy.startDate;
    detail.inf.endDate = detail.filterBy.endDate;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
    createChart(data);
    detail.skipReportPage = true; // Skip the report page
    report.show(detail, () => {
      const pageTarget = document.getElementById("accountsReceivable-page-right");

      const existingContent = pageTarget.querySelector(".accountsReceivable-dataCont");
      if (existingContent) {
        existingContent.remove();
      }

      const body = generate(data);
      pageTarget.insertAdjacentHTML("beforeend", body);
    });
  });
}

export function fetchOne(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "customer",
    report: "account-receivable-all-one",
    dbid: detail.dbid,
  };
  if (cachedReportDateFilter) {
    detail.inf.startDate = cachedReportDateFilter.startDate;
    detail.inf.endDate = cachedReportDateFilter.endDate;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}

export function fetchUnpaidInvoices(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "customer",
    report: "account-receivable-one",
    id: detail.dbid,
  };
  if (cachedReportDateFilter) {
    detail.inf.startDate = cachedReportDateFilter.startDate;
    detail.inf.endDate = cachedReportDateFilter.endDate;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}

function generate(data) {
  var body = "";
  body += generateTop(data[0]);
  body += generateTable(data);
  body += `</div> <!-- dataCont -->`;
  body += `<div class="report-page">`;

  return body;
}

function generateTop(data) {
  var table = `
    <div class="dataCont accountsReceivable-dataCont dn">
      <div ${css.title}>${data.company_name}</div>
      <div ${css.subtitle}>${data.provider} Account Receivable Aging Report As Of ${data.current_dateTime}</div>
  `;
  return table;
} /**/

function generateTable(data) {
  var totals = {
    current: 0,
    total_due_30_days: 0,
    total_due_31_to_60_days: 0,
    total_due_61_to_90_days: 0,
    total_due_over_90_days: 0,
    grandTotal: 0,
  };
  var nextFormat = 0;

  var table = `
    <h2 ${css.f15}>Customers Vs Aging Owned Amounts: This is a financial document that provides information about money 
      owed to a company by its customers or clients for goods or services provided on credit.</h2>
    <table ${css.table} class="dt-alterColor">
     <tr >
      <th ${css.th}>Customer</th>
      <th ${css.th}>Current</th>
      <th ${css.th}>30 days</th>
      <th ${css.th}>31 to 60 days</th>
      <th ${css.th}>61 to 90 days</th>
      <th ${css.th}>Over 90 days</th>
      <th ${css.th}>Total</th>   
    </tr> 
  `;

  for (let i = 0; i < data.length; i++) {
    let rowTotal = 0;
    let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"customer", "elem":"report", "reportType":"accountReceivable", "entity":"customer", "dbid":"${data[i].customer_id}", "source":"dt" } ] }'`;

    totals.current += parseFloat(data[i].current.replace(/[$,]/g, ""));
    totals.total_due_30_days += parseFloat(
      data[i].total_due_30_days.replace(/[$,]/g, "")
    );
    totals.total_due_31_to_60_days += parseFloat(
      data[i].total_due_31_to_60_days.replace(/[$,]/g, "")
    );
    totals.total_due_61_to_90_days += parseFloat(
      data[i].total_due_61_to_90_days.replace(/[$,]/g, "")
    );
    totals.total_due_over_90_days += parseFloat(
      data[i].total_due_over_90_days.replace(/[$,]/g, "")
    );

    rowTotal =
      parseFloat(data[i].current.replace(/[$,]/g, "")) +
      parseFloat(data[i].total_due_30_days.replace(/[$,]/g, "")) +
      parseFloat(data[i].total_due_31_to_60_days.replace(/[$,]/g, ""));
    rowTotal +=
      parseFloat(data[i].total_due_61_to_90_days.replace(/[$,]/g, "")) +
      parseFloat(data[i].total_due_over_90_days.replace(/[$,]/g, ""));

    totals.grandTotal += rowTotal;

    table += `
      <tr ${rowStyle(i)}>
        <td class='tdClick' ${css.td} ${detailHtml} >${data[i].customer}</td>
        <td ${css.td} >${data[i].current}</td>
        <td ${css.td} >${data[i].total_due_30_days}</td>
        <td ${css.td} >${data[i].total_due_31_to_60_days}</td>
        <td ${css.td} >${data[i].total_due_61_to_90_days}</td>
        <td ${css.td} >${data[i].total_due_over_90_days}</td>
        <td ${css.td} >${cashVal(rowTotal)}</td>
      </tr> 
    `;

    nextFormat = i + 1;
  }

  //GRAND TOTAL
  totals.grandTotal =
    totals.current +
    totals.total_due_30_days +
    totals.total_due_31_to_60_days +
    totals.total_due_61_to_90_days +
    totals.total_due_over_90_days;

  //PRINITNG EACH COLUMM TOTAL
  table += `
    <tr ${rowStyle(nextFormat)}>
      <td ${css.totalLabel}>Total</td>
      <td ${css.totalCell}>${cashVal(totals.current)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_30_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_31_to_60_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_61_to_90_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.total_due_over_90_days)}</td>
      <td ${css.totalCell}>${cashVal(totals.grandTotal)}</td>
    </tr> 
  `;
  table += `</table>`;

  return table;
}

function cashVal(value) {
  return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

function rowStyle(i) {
  if (i % 2 === 0) {
    return "";
  }
  return css.trGray;
}